import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './admin-panel/shared/shared.module';
// import { SharedModule } from './admin-panel/shared/shared.module';
import { AuthModule } from './admin-panel/pages/auth/auth.module';
import { HttpClientModule } from '@angular/common/http';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
// import { NotFoundComponent } from './admin-panel/pages/not-found/not-found.component';
// import { DashboardModule } from './admin-panel/main-panel/dashboard/dashboard.module';
import { NotFoundComponent } from './admin-panel/pages/not-found/not-found.component';
import { DashboardModule } from './admin-panel/pages/dashboard/dashboard.module';

import { NgxEchartsModule } from 'ngx-echarts';
import { AuthSignInModule } from './user-panel/auth/sign-in/sign-in.module';
import { DummyComponent } from './dummy/dummy/dummy.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TimerComponent } from './user-panel/timer/timer/timer.component';
import { EventNotFoundComponent } from './event-not-found/event-not-found.component';
import { DynamicRootComponent } from './dynamic-root/dynamic-root.component';
import { DynamicRootUserComponent } from './dynamic-root-user/dynamic-root-user.component';
import { ModalComponent } from './shared-root/modal/modal.component';
@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    DummyComponent,
    TimerComponent,
    EventNotFoundComponent,
    DynamicRootComponent,
    DynamicRootUserComponent,
    ModalComponent
  ],
  imports: [
    DashboardModule,
    BrowserModule,
    DashboardModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ToastrModule,
    SharedModule,
    AuthModule,
    AuthSignInModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
